'use client'

import { OPTIMIZELY_SCRIPT } from "@/constants/optimizely";
import { ONETRUST_PERFORMANCE_CLASS } from "@/context/onetrust";
import { createLogger } from "@/lib/debug";
import { isBrowser } from "@/lib/utils";

const logger = createLogger('optimizely');

/** Called when the Optimizely snippet has loaded. Set on window for OneTrust C0002 injector. */
export const onOptimizelyLoad = () => {
  if (isBrowser()) {
    window.optimizely.push({
      type: 'addListener',
      filter: {
        type: 'lifecycle',
        name: 'initialized',
      },
      handler: () => {
        logger.info('Optimizely initialized');
      },
    });
    window.optimizely.push({
      type: 'addListener',
      filter: {
        type: 'lifecycle',
        name: 'pageActivated',
      },
      handler: (event) => {
        logger.success(`Page '${event.data.page.name ?? event.data.page.apiName}' activated`);
      },
    });

    window.optimizely.push({
      type: 'addListener',
      filter: {
        type: 'lifecycle',
        name: 'pageDeactivated',
      },
      handler: (event) => {
        logger.info(`Page '${event.data.page.name ?? event.data.page.apiName}' deactivated`);
      },
    });

    window.optimizely.push({
      type: 'addListener',
      filter: {
        type: 'analytics',
        name: 'trackEvent',
      },
      handler: (event) => {
        logger.success(`Event '${event.data.name ?? event.data.apiName}' was tracked`);
      },
    });
  }
};



export const OptimizelyScript = (
  <script
    type="text/plain"
    className={ONETRUST_PERFORMANCE_CLASS}
    data-ot-category="C0002"
    dangerouslySetInnerHTML={{ __html: OPTIMIZELY_SCRIPT }}
  />
);
